import React from 'react';
import { useTranslation } from 'react-i18next';
import { UI_SCALE_PRESETS, getUiScalePreset } from './ui-scale.js';

const UI_SCALE_LABEL_FALLBACKS = {
  'ultra-compact': 'Ultra Compact',
  compact: 'Compact',
  default: 'Default',
  large: 'Large',
  'extra-large': 'Extra Large',
};

function UiScaleControl({ value, onChange }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);
  const selectedPreset = getUiScalePreset(value);
  const controlLabel = t('header.uiScale.label', 'Interface scale');
  const selectedPresetLabel = t(selectedPreset.labelKey, UI_SCALE_LABEL_FALLBACKS[selectedPreset.key]);
  const accessibleLabel = `${controlLabel}: ${selectedPresetLabel}, ${selectedPreset.percent}%`;

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleDocumentClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleDocumentClick);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, [isOpen]);

  const handleSelect = (presetKey) => {
    onChange(presetKey);
    setIsOpen(false);
  };

  return (
    <li
      className={`nav-item dropdown nav-icon-hover-bg rounded-circle app-ui-scale-control${isOpen ? ' show' : ''}`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="nav-link nav-icon-hover text-white border-0 bg-transparent"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-label={accessibleLabel}
        title={accessibleLabel}
      >
        <i className="ti ti-text-size" aria-hidden="true"></i>
        <span className="visually-hidden">{selectedPreset.percent}%</span>
      </button>

      {isOpen ? (
        <div className="dropdown-menu dropdown-menu-end show app-ui-scale-menu">
          <div className="dropdown-header">{controlLabel}</div>
          {UI_SCALE_PRESETS.map((preset) => {
            const isSelected = preset.key === selectedPreset.key;
            const presetLabel = t(preset.labelKey, UI_SCALE_LABEL_FALLBACKS[preset.key]);

            return (
              <button
                key={preset.key}
                type="button"
                className={`dropdown-item app-ui-scale-option${isSelected ? ' active' : ''}`}
                onClick={() => handleSelect(preset.key)}
                aria-pressed={isSelected}
              >
                <span>{presetLabel}</span>
                <span className="text-muted">{preset.percent}%</span>
              </button>
            );
          })}
        </div>
      ) : null}
    </li>
  );
}

export default UiScaleControl;
